import React from 'react';
import { render } from 'react-dom';
import Konva from 'konva';
import { Layer, Rect, Stage, Group, Text } from 'react-konva';
import { withStyles } from '@material-ui/core/styles';
import {withRouter} from 'react-router-dom'

const styles = {
};

class BoundingBoxRect extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            color: 'green',
        };
        // so we can access props and state in handleClick
        this.handleClick = this.handleClick.bind(this);
    }

    handleClick() {
        // change color if not drawing mode
        if(!this.props.isDrawingMode) {
            this.setState({
                color: Konva.Util.getRandomColor(),
            })
        }
    }

    render() {
        let { x, y, label, width, height, color } = this.props;

        let labelX = width < 0 ? x+width : x;
        let labelY = height < 0 ? y+height : y;

        let inverseX = width > 0 ? x+width : x;
        let inverseY = height < 0 ? y+height : y;
        //console.log(`Width: ${width} Height: ${height} x: ${x} y: ${y}, labelX ${labelX} labelY ${labelY}`);
        return (
            <Group>
                <Text
                    x={labelX}
                    y={labelY-30}
                    text={label}
                    fontSize={30}
                    fontFamily='Calibri'
//                    width={this.props.width}
  //                  height={this.props.height}
                    fill={color}
    //                onClick={this.handleClick}
                />          
            {/*<Text
                    x={inverseX-15}
                    y={inverseY-30}
                    text="X"
                    fontSize={30}
                    fontFamily='Calibri'
//                    width={this.props.width}
  //                  height={this.props.height}
                    fill={color}
    //                onClick={this.handleClick}
                />          */}

                <Rect
                    x={x}
                    y={y}
                    width={width}
                    height={height}
                    stroke={color}
                    onClick={this.handleClick}
                />
            </Group>
        );
    }
}

export default withRouter(withStyles(styles)(BoundingBoxRect));



// WEBPACK FOOTER //
// ./src/components/labeler/bounding_box_rect.jsx